import create from 'zustand';

const useActionLoadingStore = create(set => ({
  isLoading: false,
  setLoading: isLoading => set({ isLoading }),
}));

export default useActionLoadingStore;
